import { gql } from 'apollo-angular'

import { USER_FIELDS } from '../../fragments/user.fragment'

export const LOGIN_USER = gql`
  mutation loginUser($name: String!, $password: String!) {
    loginUser(email: $name, password: $password) {
      exp
      token
      user {
        ...UserFields
        organization {
          id
          name
        }
      }
    }
  }
  ${USER_FIELDS}
`
